import { AutoComplete, Tag, Tooltip } from "antd";
import { useState } from "react";

const SelectListFiltersSingleChoice = ({
  placeholder,
  options,
  filters,
  setFilters,
  entity,
  style,
  popupMatchSelectWidth,
  tagLength = 15,
}) => {
  const [query, setQuery] = useState("");

  const tagRender = (label) => {
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const onCloseTag = () => {
      const list = filters[`${entity}`].filter((item) => item !== label);
      setFilters({
        ...filters,
        [`${entity}`]: list.length == 0 ? null : list,
      });
    };
    const isLongTag = label.length > tagLength;
    const tagElem = (
      <Tag onMouseDown={onPreventMouseDown} closable onClose={onCloseTag}>
        {isLongTag ? `${label.slice(0, tagLength)}...` : label}
      </Tag>
    );
    return (
      <>{isLongTag ? <Tooltip title={label}>{tagElem}</Tooltip> : tagElem}</>
    );
  };
  const handleInputSearch = (value) => {
    setQuery(value);
  };
  const handleInputConfirm = (value, option) => {
    setFilters({
      ...filters,
      [`${entity}`]: [value],
    });
    setQuery("");
  };
  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  return (
    <div>
      <AutoComplete
        value={query}
        options={options}
        placeholder={placeholder}
        filterOption={filterOption}
        onSearch={handleInputSearch}
        onSelect={handleInputConfirm}
        popupMatchSelectWidth={popupMatchSelectWidth}
        style={style ? style : { width: "100%" }}
      ></AutoComplete>
      {/* <Select
          mode="multiple"
          className="filter-item"
          showSearch
          placeholder={placeholder}
          optionFilterProp="children"
          onChange={handleOnChange}
          filterOption={filterOption}
          popupMatchSelectWidth={popupMatchSelectWidth}
          options={options}
          style={
            style
              ? style
              : { width: "100%", marginBottom: "10px", height: "40px" }
          }
        /> */}
      <div className="keywords">
        {filters[`${entity}`] &&
          filters[`${entity}`].map((key) => tagRender(key))}
      </div>
    </div>
  );
};

export default SelectListFiltersSingleChoice;
